import{createContext}from"react";const ValidationContext=createContext({});export{ValidationContext};